<template>
  <Form
    class="flex flex-col md:flex-row gap-6"
    v-slot="{ values, resetForm }"
    @submit="(values) => onSubmit(values, resetForm)"
  >
    <Field
      validate-on-input
      validate-on-change
      validate-on-blur
      name="requestNumber"
      v-slot="{ field, errors: errs }"
    >
      <TextInput
        :field="field"
        :errors="errs"
        :placeholder="$t('startWriteRequestNumber')"
        class="w-full flex-1"
      />
    </Field>

    <button
      :disabled="(values.requestNumber || [])?.length < 25"
      class="group text-center rounded-md bg-primary/80 hover:bg-primary flex items-center gap-x-2 hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed text-white"
    >
      <div class="group-disabled:bg-gray-300 p-2 bg-primary rounded-s-md">
        <faMagnifyingGlass class="w-4 fill-white"></faMagnifyingGlass>
      </div>
      <span class="w-full text-center">
        {{ $t('search') }}
      </span>
      <div class="p-0.5"></div>
    </button>
  </Form>
</template>

<script setup>
import faMagnifyingGlass from '@/assets/icons/faMagnifyingGlass.svg?component'
import TextInput from '@/components/SimpleForm/TextInput.vue'
import { Field, Form } from 'vee-validate'
import { useRouter } from 'vue-router'

const router = useRouter()

const onSubmit = (form) => {
  router.push({
    name: 'IndMyRequests',
    query: form
  })
}
</script>

<style lang="scss" scoped></style>
